export default {
  name: 'implantations-map',
  ui: {
    selector: '[js-implantations-map-selector]',
    description: '[js-implantations-map-description]',
    cta: '[js-implantations-map-cta]',
    'markers[]': '[js-implantations-map-marker]',
  },
  events: [
    {
      target: 'selector',
      on: 'change',
      handle (e) {
        this.selection = this.ui.selector.value
        this.updateSelection()
      },
    },
    {
      target: 'markers',
      on: 'click',
      handle (e) {
        this.selection = e.currentTarget.dataset.slug
        this.updateSelection()
      },
    },
  ],
  componentDidMount () {
    // console.log(this.props.places)
  },

  updateSelection () {
    // on markers
    this.ui.markers.forEach(el => {
      el.classList.remove('is-active')
    })
    this.ui.markers.find(el => el.dataset.slug === this.selection).classList.add('is-active')

    // on selector
    this.ui.selector.customSelect.value = this.selection

    // on description
    const datasEntry = this.props.places.find(el => el.slug === this.selection)
    this.ui.description.innerHTML = datasEntry.description
    this.ui.cta.setAttribute('href', datasEntry.url)
  },
}
